export const fmtDate = (d) => {
  if (!d) return '';
  const parts = d.split('-');
  if (parts.length === 3 && parts[0].length === 4) return `${parts[2]}-${parts[1]}-${parts[0].slice(-2)}`;
  return d;
};

export const fmtAmt = (v) => {
  if (!v) return '0';
  return Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 });
};

export const STATUS_COLORS = {
  pending_approval: 'bg-amber-100 text-amber-800 border border-amber-300',
  approved: 'bg-green-100 text-green-700 border border-green-300',
  rejected: 'bg-red-100 text-red-700 border border-red-300',
};
